import { Link, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import "../styles/Navbar.css";

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const isActive = (path) => {
    if (path === "/" && location.pathname === "/") return true;
    if (path !== "/" && location.pathname.toLowerCase().startsWith(path.toLowerCase())) return true;
    return false;
  };

  return (
    <nav className={`navbar ${scrolled ? "scrolled" : ""}`}>
      <div className="navbar-container">
        <div className="navbar-inner">
          <Link to="/" className="logo" onClick={() => setMenuOpen(false)}>
            <span className="logo-gem">
              <span className="logo-gem-inner"></span>
            </span>
            <span className="logo-text">
              Almond<span className="logo-accent">Software</span>
            </span>
          </Link>

          {/* Desktop Links */}
          <div className="nav-links">
            <Link to="/" className={isActive("/") ? "nav-item active" : "nav-item"}>
              Home
            </Link>
            <Link to="/about" className={isActive("/about") ? "nav-item active" : "nav-item"}>
              About
            </Link>
            <Link to="/creations" className={isActive("/creations") ? "nav-item active" : "nav-item"}>
              Recent Works
            </Link>
            <Link to="/apps" className={isActive("/apps") ? "nav-item active nav-item-apps" : "nav-item nav-item-apps"}>
              <span className="apps-link-text">Apps</span>
              <span className="nav-apps-badge">4 Apps</span>
            </Link>
            <Link to="/shopify" className={isActive("/shopify") ? "nav-item active" : "nav-item"}>
              Shopify
            </Link>
            <Link to="/salesforce" className={isActive("/salesforce") ? "nav-item active" : "nav-item"}>
              Salesforce
            </Link>
            <Link to="/services" className={isActive("/services") ? "nav-item active" : "nav-item"}>
              Services
            </Link>
            <Link to="/contact" className={isActive("/contact") ? "nav-item active nav-cta" : "nav-item nav-cta"}>
              Contact
            </Link>
          </div>

          {/* Hamburger */}
          <button
            type="button"
            className={`hamburger ${menuOpen ? "open" : ""}`}
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle navigation menu"
            aria-expanded={menuOpen}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>

        {/* Mobile menu */}
        <div className={`mobile-menu ${menuOpen ? "active" : ""}`}>
          <div className="mobile-menu-inner">
            <Link to="/" className={isActive("/") ? "active" : ""} onClick={() => setMenuOpen(false)}>
              Home
            </Link>
            <Link to="/about" className={isActive("/about") ? "active" : ""} onClick={() => setMenuOpen(false)}>
              About
            </Link>
            <Link to="/creations" className={isActive("/creations") ? "active" : ""} onClick={() => setMenuOpen(false)}>
              Recent Works
            </Link>
            <Link to="/apps" className={isActive("/apps") ? "active mobile-apps-link" : "mobile-apps-link"} onClick={() => setMenuOpen(false)}>
              <span>Mobile Apps (DocNo, Forge, Players)</span>
              <span className="nav-apps-badge">Featured</span>
            </Link>
            <Link to="/shopify" className={isActive("/shopify") ? "active" : ""} onClick={() => setMenuOpen(false)}>
              Shopify
            </Link>
            <Link to="/salesforce" className={isActive("/salesforce") ? "active" : ""} onClick={() => setMenuOpen(false)}>
              Salesforce
            </Link>
            <Link to="/services" className={isActive("/services") ? "active" : ""} onClick={() => setMenuOpen(false)}>
              Services
            </Link>
            <Link to="/contact" className={isActive("/contact") ? "active" : ""} onClick={() => setMenuOpen(false)}>
              Contact Us
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
}